import React, { useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import { Box, BoxProps, Button, IconButton, Stack, TextField } from "@mui/material";

const boxSx: BoxProps["sx"] = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "white",
  borderRadius: "10px"
};

interface CreateProps {
  title: string;
  onCancel: () => void;
  onSubmit: (value: string) => void;
  submitButtonTitle?: string;
  label?: string;
}

export const Create: React.FC<CreateProps> = ({ title, onCancel, onSubmit, submitButtonTitle, label }) => {
  const [inputValue, setInputValue] = useState<string>("");

  return (
    <Box sx={boxSx}>
      <Box sx={{ background: "#fff", borderRadius: "10px 10px 0px 0px", padding: "30px 30px 0 30px" }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ borderBottom: "1px solid  #DAE0E2", paddingBottom: "5px" }}
        >
          <span>{title ? title : "CREATE ELEMENT"}</span>
          <IconButton onClick={onCancel}>
            <CloseIcon className="icon" />
          </IconButton>
        </Stack>
      </Box>
      <Stack alignItems="stretch" sx={{ p: "20px 30px 30px 30px" }}>
        <TextField
          value={inputValue}
          autoFocus
          onChange={(event) => setInputValue(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Enter" && inputValue.trim()) {
              onSubmit(inputValue);
              event.preventDefault();
              event.stopPropagation();
            }
          }}
          sx={{
            width: "400px",
            "& .MuiOutlinedInput-input": {
              padding: "12px 10px"
            }
          }}
          size="medium"
          label={label}
          fullWidth={false}
        />
        <Stack sx={{ mt: "30px" }} direction="row" justifyContent="flex-end" gap="20px">
          <Button variant="outlined" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="contained" onClick={() => onSubmit(inputValue)}>
            {submitButtonTitle ? submitButtonTitle : "Add"}
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};
